// removed by extract-text-webpack-plugin
module.exports = {"formSection":"_1oSr"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/InternetService/InternetService.scss
// module id = Vk3b
// module chunks = 0